import {StockValue} from 'features/stock/types/stock-value';
import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const getVariantsInStock = api.injectEndpoints({
  endpoints: builder => ({
    getVariantsInStock: builder.query<Response, Request>({
      query: params => ({
        method: 'GET',
        url: `stock/product-collections/${params.collectionId}/families/${params.id}/products/${params.productId}/variants`,
        params: {
          type: params.type,
        },
      }),
      forceRefetch: () => true,
    }),
  }),
});

type Request = {
  id?: ObjectId;
  collectionId?: ObjectId;
  productId?: ObjectId;
  type: string;
};

type Response = ResponseData<
  {
    id: ObjectId;
    name: string;
    stock: StockValue[];
  }[]
>;

export const {useGetVariantsInStockQuery} = getVariantsInStock;
